import React, { useState } from 'react';
import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

// Compents
import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'


const accordionData = [
    {
    id: 1,
    title:'Low Charge Ammonia',
    content: 'These systems use ammonia, a natural and efficient refrigerant, in significantly reduced quantities compared to traditional ammonia systems. This minimizes environmental impact and enhances safety. Low-charge ammonia systems offer excellent operating efficiencies across various applications, reducing energy consumption and operational costs. They are increasingly favored for their sustainability and compliance with stringent environmental regulations.'
    },
    {
    id: 2,
    title:'Pump feed Ammonia',
    content: 'Ammonia pumps are crucial components in industrial refrigeration systems using ammonia as a refrigerant. These pumps are designed to handle the specific properties of ammonia, ensuring its safe and efficient transfer. They are used in various applications, including refrigeration, chemical processing, and heat transfer. Proper pump selection is crucial to avoid issues like cavitation and ensure efficient operation.'
    }, 
    {
    id: 3,
    title:'HFC Freon DX',
    content: 'R404A and R507 are blended refrigerants used as alternatives to CFC and HCFC refrigerants in commercial refrigeration. They offer similar performance characteristics, with R-507 providing slightly better cooling rates. These refrigerants are commonly used in low and medium-temperature refrigeration systems, such as display cases and refrigerated transport. However, they have a high global warming potential, leading to a search for more environmentally friendly alternatives.'
    },
    {
    id: 4,
    title:' CO2 Subcritical & Transcritical',
    content: 'CO2 refrigeration systems are gaining popularity due to their use of a natural refrigerant with a negligible global warming potential. Subcritical systems operate below the critical point of CO2, while transcritical systems operate above it. Transcritical systems are suitable for a wider range of climates and offer high efficiency. Both types are considered sustainable and reliable options for industrial refrigeration, with increasing adoption in various industries.'
    }
]

function Refrigeration() {
     useGaspAnimations()
//  const [openSections, setOpenSections] = useState({});
  const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

 const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

      var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
         {
            breakpoint: 1000,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };

    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
 
{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Industrial Refrigeration Refpacks</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Industrial Refrigeration Refpacks</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area" className="smartphone-repair-area">
    <div className="container">
        <div className="row">
             <ProductFilter/>
                 
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeUp">
                            <img src="assets/images/OurProducts/Industrial-Refrigeration-Refpacks.webp" alt="Awesome Image"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className='icon'>
                                        <img src="assets/images/Walrus_Logo.png" alt="Awesome Image"/>
                                    </div>
                                <div className="title bdFadeUp sec-title">
                                    
                                    <h1 className='title-anim'><span>Skid Mounted Refrigeration  Pack</span></h1>
                                </div>
                                <div className="text bdFadeUp">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                        Industrial refrigeration refpacks are specialized systems designed for large-scale industrial applications. They efficiently generate low temperature refrigeration for industrial processes, ensuring optimal equipment performance, product quality, and a safe working environment. These systems are crucial in industries like food processing, chemical plants, and pharmaceuticals, where precise process temperature  is essential. Industrial refpacks are deisgned for  energy savings and compliance with environmental regulations.
                                    </p>
                                    <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                            
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                     <div className="row middle-content">
                        <div className="col-md-7">
                            <div className="text-holder">
                                <div className="title">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text">
                                    
                                    <ul>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Green Refrigerent  Ammonia Low Charge </li>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Pump feed Ammonia</li>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>Green refrigerent CO2 Subcritical and Transcritical systems</li>
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>HFC Freon DX Systems</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                              <Slider {...settings}>
                                        <img src="assets/images/OurProducts/industrial-refrigeration/BMR-Refpack-with-MYCOM-1.jpeg" alt="Awesome Image"/>
                                        <img src="assets/images/OurProducts/industrial-refrigeration/BMR-Refpack-with-MYCOM-2.jpeg" alt="Awesome Image"/>
                                        <img src="assets/images/OurProducts/industrial-refrigeration/RefPack-System-with-Screw-or-Reciprocating-compressor-768x505.jpg" alt="Awesome Image"/>
                                    </Slider>
                        </div>
                    </div>
                    {/* <!--End middle content--> */}


               
                    


                    {/* <!--Start bottom content--> */}
                    <div className="row bottom-content">
                        <div className="col-md-12">
                               <div className="title">
                                    <h2>Sub-category Descriptions</h2>
                                </div>
                            <div className="accordion-box">
                                {accordionData.map(({ id, title, content }) => (
                                <>
                                 {/* <!--Start single accordion box--> */}
                                <div className="accordion accordion-block" key={id}>
                                    <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                    {openSections[id] && (
                                    <div className="accord-content collapsed">
                                        <p>
                                        {content}
                                        </p>
                                    </div>
                                    )}
                                </div>
                                 {/* <!--End single accordion box-->  */}
                                </>
                                ))}
                         
                               
                            </div>    
                        </div>
                    </div>
                    {/* <!--End bottom content--> */}
                   
                </div>
            </div>
          
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}
 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Refrigeration;



